/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Years_ExperienceInputs */

const en_years_experience = /** @type {(inputs: Years_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`35 years experience`)
};

const th_years_experience = /** @type {(inputs: Years_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ประสบการณ์ 35 ปี`)
};

const ja_years_experience = /** @type {(inputs: Years_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`35年の実績`)
};

const fr_years_experience = /** @type {(inputs: Years_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`35 ans d’expérience`)
};

const es_years_experience = /** @type {(inputs: Years_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`35 años de experiencia`)
};

const ru_years_experience = /** @type {(inputs: Years_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`35 лет опыта`)
};

const zh_years_experience = /** @type {(inputs: Years_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`35 年经验`)
};

const vi_years_experience = /** @type {(inputs: Years_ExperienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`35 năm kinh nghiệm`)
};

/**
* | output |
* | --- |
* | "35 years experience" |
*
* @param {Years_ExperienceInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const years_experience = /** @type {((inputs?: Years_ExperienceInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Years_ExperienceInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_years_experience(inputs)
	if (locale === "ja") return ja_years_experience(inputs)
	if (locale === "fr") return fr_years_experience(inputs)
	if (locale === "es") return es_years_experience(inputs)
	if (locale === "ru") return ru_years_experience(inputs)
	if (locale === "zh") return zh_years_experience(inputs)
	if (locale === "vi") return vi_years_experience(inputs)
	return en_years_experience(inputs)
});